import type { MongoAbility } from "@casl/ability"

import type { WorkspaceAccessModule } from "@/features/auth/model/auth-types"

/** Actions used for workspace module entitlements (maps from API VIEW / EDIT). */
export type AppAction = "read" | "update"

/**
 * CASL subject for branch-level administrative authority. Granted per-branch when the user's
 * an assigned role grants branch administration. This is no longer a {@link WorkspaceAccessModule} (BRANCH_ADMINISTRATION
 * was removed); it is an authority subject driven by the branch role.
 */
export const BranchAdministration = "BranchAdministration" as const
export type BranchAdministrationSubject = typeof BranchAdministration

/** Branch-scoped settings authority. It deliberately does not grant team/user administration. */
export const WorkspaceSettingsManagement = "WorkspaceSettingsManagement" as const
export type WorkspaceSettingsManagementSubject = typeof WorkspaceSettingsManagement

/**
 * Organization-governance CASL subjects (workspace-scoped only). These have no {@link WorkspaceAccessModule}
 * equivalent — they back the new `branches` / `roles` / `subscription` permission modules on Organization roles.
 */
export const BranchesManagement = "BranchesManagement" as const
export const RolesManagement = "RolesManagement" as const
export const SubscriptionManagement = "SubscriptionManagement" as const
export type OrgGovernanceSubject =
  | typeof BranchesManagement
  | typeof RolesManagement
  | typeof SubscriptionManagement

/** CASL subject: one per `WorkspaceAccessModule` value, plus the authority + org-governance subjects. */
export type AppSubject =
  | WorkspaceAccessModule
  | BranchAdministrationSubject
  | WorkspaceSettingsManagementSubject
  | OrgGovernanceSubject

export type AppAbility = MongoAbility<[AppAction, AppSubject]>
